module.exports = __webpack_public_path__ + "media/application/images/logo-enginei-47fa17b0469356a9320fa206d38c57f3.svg";